module.exports = __webpack_public_path__ + "static/img/value05.cefde33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/value05.png
// module id = Fxy+
// module chunks = 0